import { Response } from 'src/app/interfaces/interface-bakend/response';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const URL_BACKEND = environment.urlBackend;

/**
 * Cliente crudo de GECROS. Solo pega a los endpoints de /signo-gecros; la
 * orquestación del sync vive en GecrosSyncService.
 */
@Injectable({ providedIn: 'root' })
export class GecrosAfiliadosService {

    constructor(private httpClient: HttpClient) { }

    async getAfiliadoByIdentificacion(identificacion: string): Promise<any> {
        return new Promise(async (resolve) => {
            this.httpClient
                .get<Response>(`${URL_BACKEND}/signo-gecros/afiliadoByNDoc/${identificacion}`)
                .subscribe((resp: Response) => {
                    resolve(resp.response);
                });
        });
    }

    async statusGecros(): Promise<boolean> {
        try {
            const resp = await this.httpClient
                .get<Response>(`${URL_BACKEND}/signo-gecros/status`)
                .toPromise();

            if (Array.isArray(resp.response) && resp.response.length > 0) {
                return true;
            }

            if (typeof resp.response === 'string' && resp.response.trim() !== '') {
                return true;
            }

            return false;
        } catch (error) {
            console.error('Error al obtener el estado de GECROS:', error);
            return false;
        }
    }
}
